import _implicitStylesheets from "./harnessIcon.css";
import _implicitScopedStylesheets from "./harnessIcon.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"c0"}${"a0:src"} alt=""${2}>`;
const stc0 = {
  "aria-hidden": "true",
  "data-testid": "harness-icon"
};
const stc1 = {
  classMap: {
    "harness-icon__astro": true
  },
  props: {
    "icon": "agent_astro"
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, fr: api_fragment, c: api_custom_element, h: api_element} = $api;
  return [$cmp.hasIcon ? api_fragment(0, [api_element("span", {
    className: api_normalize_class_name($cmp.tileClass),
    attrs: stc0,
    key: 1
  }, [$cmp.imageSrc ? api_fragment(2, [api_static_fragment($fragment1, 4, [api_static_part(0, {
    className: api_normalize_class_name($cmp.imageClass),
    attrs: {
      "src": $cmp.imageSrc
    }
  }, null)])], 0) : $cmp.isAgentforceVibes ? api_fragment(2, [api_custom_element("ax-icon", _axIcon, stc1)], 0) : null])], 0) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1vdhab8e0vt";
tmpl.legacyStylesheetToken = "undefined-_harnessIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
